import { Circle, BookOpen, Edit, Book } from "react-feather";

export default [
	{
		header: "Судалгаа",
	},
	{
		id: "survey",
		title: "Судалгаа авах",
		// icon: <i className="far fa-balance-scale"></i>,
		icon: <Edit />,
        children: [
            {
				id: "takesurvey",
				title: "Судалгаа авах",
				icon: <Circle size={12} />,
				navLink: "/survey/addsurvey",
			},
			{
				id: "surveyresults",
				title: "Судалгааны үр дүн",
				icon: <Circle size={12} />,
				navLink: "/survey/results",
			},
        ]
    },


]
